import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequest } from '../../../common/Common';
import { getTotal } from '../../../common/Util';
import { TARGET_YEAR_API } from '../../../common/data';
// import { filterNonItemList } from './util';

const initialState = {
  isRender: false,
  reload: -1,
  dataList: [],
  //공제 불가 항목
  nonItemList: [],
  //원본데이터
  originalDataList: [],

  // 합계
  total: 0,
  //보험료 상세
  insuranceDetail: {},

  selectedInsuranceDetail: {},
};

//보험료 불러오기
export const getInsuranceInfo = createAsyncThunk('insurance/getInsuranceInfo', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S5`);
  return response;
});

//보험료 저장
export const updateInsuranceInfo = createAsyncThunk('insurance/updateInsuranceInfo', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S5AE`, data);
  return response;
});

//보험료 상세 불러오기
export const getInsuranceDetail = createAsyncThunk('insurance/getInsuranceDetail', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S5`, data);
  return response;
});

const insuranceSlice = createSlice({
  name: 'insuranceSlice',
  initialState,
  reducers: {
    confirmDelete: (state, action) => {
      const { index } = action.payload;
      state.dataList = state.dataList.filter((_, idx) => idx !== index);
    },
    setSelectedInsuranceDetail: (state, action) => {
      state.selectedInsuranceDetail = action.payload;
    },
    setReload: (state, action) => {
      state.reload = Math.random();
    },
    // resetInsuranceState: state => {
    //   return {
    //     ...initialState,
    //     selectedInsuranceDetail: state.selectedInsuranceDetail,
    //   };
    // },
    resetInsuranceState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(getInsuranceInfo.pending, state => {
      // state.dataList = [];
      // state.nonItemList = [];
      state.isRender = false;
    });
    builder.addCase(getInsuranceInfo.fulfilled, (state, action) => {
      console.log('보험료 리스트 >>', action.payload);
      const { list } = action.payload;
      if (list) {
        state.dataList = list;
        let totalList = list.filter(item => {
          return item.deType == '1';
        });

        state.total = getTotal(totalList, ['htm016', 'htm017', 'htm018', 'htm019']);
      }
      state.isRender = true;
    });

    builder.addCase(updateInsuranceInfo.fulfilled, (state, action) => {
      console.log('보험료 저장 성공 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });

    builder.addCase(getInsuranceDetail.fulfilled, (state, action) => {
      console.log('보험료 상세 성공 >>', action.payload);
      const { list } = action.payload;
      if (list && list.length > 0) {
        state.insuranceDetail = list[0];
      } else {
        state.insuranceDetail = {};
      }
    });
  },
});

export const { confirmDelete, resetInsuranceState, setSelectedInsuranceDetail, setReload } =
  insuranceSlice.actions;
export default insuranceSlice.reducer;
